<template>
  <v-combobox
    chips
    clearable
    v-model="selected"
    :items="phoneNumbersFiltered"
    :label="$t('chat.newConversation.phoneNumber')"
    :loading="loading"
    :filter="filterObject"
  >
    <template v-slot:selection="data">
      <v-chip
        v-bind="data.attrs"
        :input-value="data.selected"
        @click="data.select"
      >
        <v-avatar left>
          <v-img v-if="data.item.hasImage" :src="data.item.imageUrl" :alt="data.item.name"></v-img>
          <v-img v-else src="/default_picture_profile.png" :alt="data.item.name"></v-img>
        </v-avatar>
        <span v-if="typeof(selected) == 'object'">{{ `${data.item.name} (${data.item.phoneNumber})` }}</span>
        <span v-else>{{ selected }}</span>
      </v-chip>
    </template>
    <template v-slot:item="data">
      <template>
        <v-list-item-avatar>
          <v-img v-if="data.item.hasImage" :src="data.item.imageUrl" :alt="data.item.name"></v-img>
          <v-img v-else src="/default_picture_profile.png" :alt="data.item.name"></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title v-html="data.item.name"></v-list-item-title>
          <v-list-item-subtitle v-html="`${data.item.label}: ${data.item.phoneNumber}`"></v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </template>
  </v-combobox>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'contact-phone-number-autocomplete',
  props: {
    includeExtensions: {
      type: Boolean,
      required: true
    },
    includeFeatureCodes: {
      type: Boolean,
      default: false
    },
    includeParkings: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      phoneNumbers: 'contacts/phoneNumbers/phoneNumbers',
      getSelected: 'contacts/phoneNumbers/autocompleteSelected'
    }),
    phoneNumbersFiltered () {
      let data = this.phoneNumbers
      if (this.includeExtensions === false) {
        data = data.filter(phoneNumber => {
          return phoneNumber.label !== 'Extension'
        })
      }
      if (this.includeFeatureCodes === false) {
        data = data.filter(phoneNumber => {
          return phoneNumber.name !== 'feature_code'
        })
      }
      if (this.includeParkings === false) {
        data = data.filter(phoneNumber => {
          return phoneNumber.name !== 'parking'
        })
      }
      return data
    },
    selected: { get () { return this.getSelected }, set (selected) { this.setSelected(selected) } }
  },
  methods: {
    ...mapActions({
      setSelected: 'contacts/phoneNumbers/setAutocompleteSelected'
    }),
    // allow to auto complete on both phone numbers and contact name
    filterObject (item, queryText, itemText) {
      if (this.includeExtensions) {
        return (
          item.phoneNumber.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 || item.name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
        )
      } else {
        return (
          item.label !== 'Extension' && (item.phoneNumber.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 || item.name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1)
        )
      }
    }
  }
}
</script>

<style>
</style>
